import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const TokenWrapper = styled(Container)`
    background-color:#000B29;
    padding-bottom:80px;
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items: center;
    @media(max-width: 900px){
        padding-top:25px;
    }
`

const Wrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    align-items:center;
    padding-top:0px;
    padding-bottom:80px;
    @media (max-width: 749px){
        padding-top:0px;
        padding-bottom:60px;
    }
    @media (min-width: 1024px){
        padding-top:80px;
        padding-bottom:60px;
    }
`

const Heading = styled(Typography)`
    font-size:25px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    text-transform:uppercase;
    color:#fff;
    text-align:center;
    @media(max-width: 900px){
        font-size:20px;
    }
`
const HeaderGrid = styled(Grid)`
    display:flex;
    justify-content:center;
    align-items:center;
    padding-top:40px;
    padding-bottom:50px;
    @media (max-width: 749px){
        padding-top:0px;
        padding-bottom:80px;
    }
`
const Headerimg = styled.img`
    width:100%;    
    height: auto;
    @media(min-width: 750px){
        width:60%;
        max-width:100%;
        height: auto;
    }
    
`
const BoxDiv = styled.div`
    background-image:url("./assets/box-bg.png");
    padding:30px;
    background-size: 100% 100%;
    background-repeat:no-repeat;
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    margin:0px 10px;
    font-size:14px;
    @media (max-width: 900px) and (min-width: 750px){
        padding:20px 10px;
    }
    @media (max-width: 749px){
        padding:20px;
        margin:10px 5px;
    }
`
const BoxImg = styled.img`
    height: auto;
    width: 67px;
    max-width: 100%;
    @media (max-width: 329px){
        height: auto;
        width:33px;
        max-width: 100%;
    }
    @media(max-width: 749px) and (min-width: 330px){
        height: auto;
        width:43px;
        max-width: 100%;
    }
`
const BoxHeading = styled(Typography)`
    color:#fff;
    font-family:Emulogic-zrEw;
    font-weight:400;
    font-size:16px;
    text-align:center;
    margin:10px 0px;
    @media (max-width: 900px) and (min-width: 750px){
        font-size:14px;
    }
    @media(max-width: 749px){
     font-size:14px;
    }
    @media (max-width: 329px){
        font-size:12px;
    }
`
const P = styled.p`
    color:#fff;
    font-family:Poppins;
    font-size:14px;
    text-align:center;
    @media(max-width: 749px){
     font-size:12px;
    }
    @media (max-width: 329px){
        font-size:10px;
    }
    @media (max-width: 900px) and (min-width: 750px){
        font-size:12px;
    }
`
const BoxGrid = styled(Grid)`
    display:flex;
    justify-content:center;
`
const DetailGrid = styled(Grid)`
    background-image:url("./assets/tokendetail-bg.png");
    background-size:100% 100%;
    background-repeat:no-repeat;
    padding:50px 70px;
    display: flex;
    align-items: center;
    @media(max-width: 900px) and (min-width: 750px){
        padding:20px 40px;
    }
    @media(max-width: 749px){
        padding:47px 20px;
    }
`
const TokenP = styled.p`
    color:#fff;
    font-size:15px;
    font-weight:400;
    font-family:poppins;
    @media(max-width: 900px){
        font-size:12px;
    }
`
const TokenDetails = styled.div`
    background-image:url("./assets/details-div-bg.png");
    background-size:100% 100%;
    padding:10px 20px;
    margin:10px 5px;
    @media(max-width: 900px){
        padding:10px 15px;
    }
`
const TokenDetailsLong = styled.div`
    background-image:url("./assets/long-bg.png");
    background-size:100% 100%;
    padding:10px 15px;
    margin:10px 5px;
    @media(max-width: 900px){
        padding:10px 10px;
    }
`
const DetailsWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    @media (max-width: 600px){
        flex-direction:column;
    }
`
const BuyBtn = styled.a`
    color:#000;
    font-size:16px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    background-image:url("./assets/buybtn-bg.png");
    background-repeat: no-repeat;
    padding:10px 20px;
    background-size:100% 100%;
    @media(max-width: 375px){
        font-size:10px;
    }
    @media(max-width: 900px) and (min-width: 750px){
        margin-top:0px;
    }
`
const ChartBtn = styled.a`
    color:#000;
    font-size:16px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    background-image:url("./assets/chartbtn.png");
    background-size:100% 100%;
    padding:10px 20px;
    margin-left:20px;
    @media(max-width: 375px){
        font-size:10px;
    }
    @media(max-width: 900px) and (min-width: 750px){
        margin-top:0px;
    }
`
const BtnGrid = styled(Grid)`
    margin-top:30px;
    display:flex;
    @media(max-width: 749px){
        justify-content:center;
        align-items:center;
    }
`
const BottomWrapper = styled(Grid)`

`
const TokenDetailsImg = styled.img`
    width: 300px;
    max-width: 100%;
    height: auto;
`
const ImgWrapper = styled(Grid)`
    display:flex;
    justify-content:center;
    align-items:center;
`
function Tokenomics(){
    return(
        <>
        <TokenWrapper maxWidth="xxl" id="tokenomics">
            <Grid container item xs={12} xl={10}>
                <Wrapper item xs={12}>
                    <div  data-aos="fade-right" style={{display:"flex",justifyContent:"center"}}>
                        <Headerimg src="./assets/win-img.png"/>
                    </div>
                </Wrapper>
                <BoxGrid item xs={12} sm={4}  data-aos="zoom-in">
                    <BoxDiv>
                        <BoxImg src="./assets/Group 6987.png" />
                        <BoxHeading>Transparency & Security</BoxHeading>
                        <P>The decentralized nature of the blockchain ensures
                             transparent and secure transactions, providing players
                              with a trusted gaming environment. 
                        </P>
                    </BoxDiv>
                </BoxGrid>
                <BoxGrid item xs={12} sm={4} data-aos="zoom-in">
                    <BoxDiv>
                        <BoxImg src="./assets/handle.png" />
                        <BoxHeading>Seamless Integration</BoxHeading>
                        <P>Pacman seamlessly integrates blockchain technology
                             into the gaming experience, allowing players to earn 
                             rewards and take part in a vibrant gaming economy.
                        </P>
                    </BoxDiv>
                </BoxGrid>
                <BoxGrid item xs={12} sm={4} data-aos="zoom-in">
                    <BoxDiv>
                        <BoxImg src="./assets/Union 24.png" />
                        <BoxHeading>Global Competition</BoxHeading>
                        <P>Engage in thrilling challenges with players
                             from all around the world, showcasing your
                              skills and earning valuable tokens.
                        </P>
                    </BoxDiv>
                </BoxGrid>
            </Grid>
        </TokenWrapper>
        <TokenWrapper maxWidth="xxl">
            <Grid container>
                <HeaderGrid item xs={12}>
                    <Heading variant="h1">Token Details</Heading>
                </HeaderGrid>
            </Grid>
            <DetailGrid container item xs={12} xl={10}>
                <ImgWrapper data-aos="zoom-in" item xs={12} sm={4} sx={{padding:'10px'}}>
                    <TokenDetailsImg src="./assets/tokendetail-img.png" />
                </ImgWrapper>
                <BottomWrapper item xs={12} sm={8}>
                    <DetailsWrapper>
                        <Grid item xs={12} sm={4}><TokenDetails><TokenP>Symbol: $PACMAN</TokenP></TokenDetails></Grid>
                        <Grid item xs={12} sm={4}><TokenDetails><TokenP>Supply: 100,000,000</TokenP></TokenDetails></Grid>
                        <Grid  item xs={12} sm={4}><TokenDetails><TokenP>Taxes: 5/5</TokenP></TokenDetails></Grid>
                    </DetailsWrapper>
                    <Grid item xs={12}><TokenDetailsLong><TokenP>Contract: 0xFa755bEC92888376f7969f1Cc4649c645950f81e</TokenP></TokenDetailsLong></Grid> 
                    <BtnGrid item xs={12}><BuyBtn target="_blank" href="https://app.uniswap.org/#/swap?outputCurrency=0xFa755bEC92888376f7969f1Cc4649c645950f81e&chain=mainnet" data-aos="zoom-in">Buy Now</BuyBtn>
                    <ChartBtn target="_blank" href="https://www.dextools.io/app/en/ether/pair-explorer/0x11ce3fe4fc63dd1105e12d3ecae5f64541e7e2c3" data-aos="zoom-in">View Chart</ChartBtn></BtnGrid> 
                </BottomWrapper> 
            </DetailGrid>
        </TokenWrapper>
        </>
    );
}

export default Tokenomics;